import { create } from "zustand";

import { RtsScannedDataReq } from "../../app/models/requestModels/rtsRequest";
import { RtsEventType } from "../dedicatedDelivery/DdTypes";
import { RtsEventTypesResponse } from "../../app/models/responseModels/rtsEventTypesResponse";
import { Client } from "../../app/models/responseModels/clientsResponse";

//interface for RtsScannedState
interface RtsScannedState {
  assocClientId: number | undefined;
  latestScanBarcode: string;
  latestImage: string;
  rtsUserClient: Client | undefined;
  setLatestScanBarcode: (barcode: string) => void;
  setLatestImage: (image: string) => void;
  scannedData: RtsScannedDataReq[];
  eventTypes: RtsEventType[];
  location: {
    latitude: number;
    longitude: number;
    isFenced: boolean;
    clientId?: number;
    storeId?: string;
    storePk?: number;
    redundantLocations?: any;
  };
  setLocation: (
    latitude: number,
    longitude: number,
    isFenced: boolean,
    storeId?: string,
    clientId?: number,
    storePk?: number,
    redundantLocations?: any
  ) => void;
  setAssocClientId: (clientId: number | undefined) => void;
  setRtsUserClient: (rtsUserClient: Client | undefined) => void;
  setEventTypes: (eventTypes: RtsEventTypesResponse[]) => void;
  addScannedData: (singleScanData: RtsScannedDataReq) => void;
  removeScannedData: (uuid: string) => void;
  resetScannedData: () => void;
}

const RtsScanStore = create<RtsScannedState>((set) => ({
  //initial state
  latestScanBarcode: "",
  assocClientId: undefined,
  rtsUserClient: undefined,

  setAssocClientId: (clientId: number | undefined) =>
    set((state: any) => ({
      assocClientId: clientId,
    })),

  setRtsUserClient: (client: Client | undefined) =>
    set(() => ({
      rtsUserClient: client,
    })),

  latestImage: "",
  scannedData: [],

  // event types
  eventTypes: [],

  location: { latitude: 0, longitude: 0, isFenced: false },

  setLocation: (
    latitude: number,
    longitude: number,
    isFenced: boolean,
    storeId?: string,
    clientId?: number,
    storePk?: number,
    redundantLocations?: any
  ) =>
    set(
      (state: any) => ({
        location: {
          latitude: latitude,
          longitude: longitude,
          isFenced: isFenced,
          storeId: storeId,
          clientId: clientId,
          storePk: storePk,
          redundantLocations: redundantLocations,
        },
      }),
      false
    ),

  setLatestScanBarcode: (barcode: string) =>
    set((state: any) => ({
      latestScanBarcode: barcode,
    })),

  setLatestImage: (image: string) =>
    set((state: any) => ({
      latestImage: image,
    })),
  setEventTypes: (data: RtsEventTypesResponse[]) =>
    set(
      (state: any) => ({
        eventTypes: data,
      }),
      false
    ),

  //on addition of singleScan data
  addScannedData: (singleScan: RtsScannedDataReq) =>
    set(
      (state: any) => ({
        scannedData: [...state.scannedData, singleScan],
      }),
      false
    ),

  //on removal, check if there is no match with uuid, then don't remove.
  removeScannedData: (uuid: string) =>
    set(
      (state: any) => ({
        scannedData: state.scannedData.filter(
          (scanData: RtsScannedDataReq) => scanData.uuid !== uuid
        ),
      }),
      false
    ),
  resetScannedData: () => {
    set((state: any) => ({
      scannedData: [],
      latestScanBarcode: "",
    }));
  },
}));

export default RtsScanStore;
